import { gql } from 'urql';

const fundingOptionsQuerySectioned = gql`
  query FundingOptionsSectioned($input: FundingOptionsSectionedInput!) {
    fundingOptionsSectioned(input: $input) {
      __typename
      ... on FundingOptionsSectionedSuccess {
        title
        sections {
          title
          key
          options {
            id
            type
            title
            description
            clickAnalytics {
              name
              properties {
                key
                value
              }
            }
          }
        }
        skipButton {
          text
          clickAnalytics {
            name
            properties {
              key
              value
            }
          }
        }
      }
      ... on FundingOptionsError {
        message
      }
    }
  }
`;

export default fundingOptionsQuerySectioned;
